const PRODUCT_CARD_COMPONENT = 'product-card';

if (!customElements.get(PRODUCT_CARD_COMPONENT)) {
  class ProductCard extends HTMLElement {
    #boundSwatchChangeHandler = null;

    constructor() {
      super();
      this.productCard = this;
      this.variantElements = this.querySelectorAll('.js-variant-element');
      this.swatches = this.productCard.querySelectorAll('.js-swatch');
    }

    connectedCallback() {
      this.initEventListeners();
      this.initializeActiveVariant();
    }

    disconnectedCallback() {
      if (this.#boundSwatchChangeHandler) {
        this.removeEventListener('change', this.#boundSwatchChangeHandler);
      }
    }

    initEventListeners() {
      this.#boundSwatchChangeHandler = this.handleSwatchChange.bind(this);
      this.addEventListener('change', this.#boundSwatchChangeHandler);
    }

    handleSwatchChange(event) {
      const swatch = event.target.closest('.js-swatch');
      if (!swatch) return;

      const swatchValue = swatch.value;
      this.changeVariant(swatchValue);
    }

    changeVariant(swatchValue) {
      let activePriceVariant = null;

      this.variantElements.forEach(variant => {
        variant.classList.remove('is-active');

        if (variant.dataset.colorName === swatchValue) {
          variant.classList.add('is-active');
          
          if (variant.classList.contains('related-price-item')) {
            activePriceVariant = variant;
          }
        }
      });

      if (activePriceVariant) {
        this.updateProductInfo(activePriceVariant);
      }
    }

    initializeActiveVariant() {
      const activePriceVariant = this.querySelector('.related-price-item.js-variant-element.is-active');
      if (activePriceVariant) {
        this.updateProductInfo(activePriceVariant);
      }
    }

    updateProductInfo(activeVariant) {
      const productUrl = activeVariant.dataset.productUrl;
      const productTitle = activeVariant.dataset.productTitle;

      if (productTitle) {
        const titleLink = this.querySelector('.product-card__title-link');

        if (titleLink) {
          titleLink.textContent = productTitle;

          if (productUrl) {
            titleLink.href = productUrl;
          }
        }
      }

      this.#updateSavingsBadge(activeVariant);
    }

    #updateSavingsBadge(activeVariant) {
      const savingsBadge = this.querySelector('.grid-product__price--savings');
      if (!savingsBadge) return;

      const showSaveAmount = window.theme?.settings?.showSaveAmount;
      if (!showSaveAmount) {
        savingsBadge.style.display = 'none';
        return;
      }

      const onSale = activeVariant.dataset.onSale === 'true';
      const compareAtPrice = parseFloat(activeVariant.dataset.compareAtPrice);
      const price = parseFloat(activeVariant.dataset.price);

      if (!onSale || !compareAtPrice || !price) {
        savingsBadge.style.display = 'none';
        return;
      }

      const savedAmount = compareAtPrice - price;
      const saveType = this.#getSaveType();

      let formattedSavings;
      if (saveType === 'dollar') {
        formattedSavings = this.#formatMoney(savedAmount);
      } else {
        const percentage = Math.round((savedAmount * 100) / compareAtPrice);
        formattedSavings = `${percentage}%`;
      }

      const saveText = this.#getSaveText(formattedSavings);
      savingsBadge.textContent = saveText;
      savingsBadge.style.display = '';
    }

    #getSaveType() {
      return window.theme?.settings?.saveType || 'percent';
    }

    #getSaveText(amount) {
      const saveTemplate = window.theme?.strings?.savePrice || 'Save [saved_amount]';
      return saveTemplate.replace('[saved_amount]', amount);
    }

    #formatMoney(cents) {
      const moneyFormat = window.theme?.settings?.moneyFormat || '€{{amount}}';
      const value = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', value)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', value.replace('.', ','));
    }
  }

  customElements.define(PRODUCT_CARD_COMPONENT, ProductCard);
}